import Modal from "react-responsive-modal";
import projectServices from "./projectServices";
import React, { Suspense, useState, useEffect } from "react";

export default function ProjectSettingStatus(param: any) {

    const [ContractStatuses, setContractStatuses] = useState<[]>([]);
    const [excludedContractStatuses, setExcludedContractStatuses] = useState<[]>([]);
    const [excludedProductStatuses, setExcludedProductStatuses] = useState<[]>([]);

    const pickerColors = [
        '#EF534F', '#C62928', '#980A0B',
        '#BA69C8', '#7B1FA2', '#4A148C',
        '#FFD54F', '#F57C02', '#E65100',
        '#81C784', '#2F7D31', '#1A5E20',
        '#7FDEEA', '#00838F', '#004D41',
        '#90CAF9', '#029BE5', '#01579B',
        '#FFFFFF', '#DBDBDB', '#000000'
    ];

    var ProjectContractStatusExclude = {
        area : "ProjectContractStatusExclude",
        code : 10089,
        isActive  : 1,
        isCustom   :    1,
        referenceCode  :    param.project.projectId,
        text  :   "In Setup"
    }

    useEffect(() => {
        getContract();
    }, [param])

    const closeStatus = () => {
        param.closeStatus(true);
    }

    const getContract = () => {

        if (param.type === "Contract") {
            projectServices.getContractStatus({ "pageNumber": 1, "pageSize": 1000 }).then((res) => { setContractStatuses(res); });
            projectServices.getExcludedContractStatus({ "referenceCode": param.project.projectId, "text": '', "pageNumber": 1, "pageSize": 10 }).then((data) => { setExcludedContractStatuses(data); })

        }

        if (param.type === "Product") {
            projectServices.getProductStatus({ "pageNumber": 1, "pageSize": 1000 }).then((res) => { setContractStatuses(res); })
            projectServices.getExcludedProductStatus({ "referenceCode": param.project.projectId, "text": '', "pageNumber": 1, "pageSize": 10 }).then((data) => { setExcludedProductStatuses(data); })
        }

        console.log(ContractStatuses)
    }

    const addProductTag = (e: any) => {
        console.log(e)
        if (param.type === "Contract") {
            ProjectContractStatusExclude.area = "ProjectContractStatusExclude";
            ProjectContractStatusExclude.text = e.statusName;
            projectServices.addProjectTag( ProjectContractStatusExclude).then((data) => { getContract(); })
        }

        if (param.type === "Product") {
            ProjectContractStatusExclude.area = "ProductStatusExclude";
            ProjectContractStatusExclude.text = e.productStatusName;
            projectServices.addProjectTag( ProjectContractStatusExclude).then((data) => { getContract(); })
        }
    }

    const removeProductTag = (e: any) => {
        console.log(e)
        if (param.type === "Contract") {            
            projectServices.removeProjectTag(e.id).then((data) => { getContract(); })
        }

        if (param.type === "Product") {
            projectServices.removeProjectTag(e.id).then((data) => { getContract(); })
        }
    }


    return (
        <>
            <Modal open={param.open} onClose={() => { closeStatus() }} center>
                <div className="row-fluid box-header-fix" >
                    <div className="box">
                        <div className="box-header well"><h2> <i className="fa fa-search"></i> {param.type === "Contract" ? "Contract Status" : "Product Status"} </h2> </div>
                        <div className="box-content">

                            <div className="row-fluid">
                                <div className="ws-12">

                                    <div>
                                        <div className="ws-6 pm">
                                            <div className="box">
                                                <div className="box-header"> <h1 className="panel-title">Include</h1> </div>
                                                <div className="box-content">

                                                    <ul dnd-list="getExcludedContractSts" className="listStyle pLarge">
                                                        {(ContractStatuses.length === 0 && param.type === "Contract") && <li>No Tags Available</li>}
                                                        {(ContractStatuses.length === 0 && param.type === "Product") && <li>No Tags Available</li>}

                                                        {param.type === "Contract" && ContractStatuses.filter((item: any) => !excludedContractStatuses.some((values: any) => item.statusName?.includes(values.text))).map((values: any, index: any) => (

                                                            <>{(values.statusName) && <a key={1} className="btn mb ws-12 ms p0" style={{ background: pickerColors[index], color: "#FFFFFF" }}>
                                                                <span className="ws-10 mt text-center forceSingleLine" style={{ background: pickerColors[index], color: "#FFFFFF" }}>{values.statusName}</span>
                                                                <span className="pull-right ws-2 pr pt" onClick={() => addProductTag(values)}>
                                                                    <i className="icon-plus1 text-xl"></i>
                                                                </span>
                                                            </a>}

                                                                {(!values.statusName) && <li>No Tags Available</li>}</>

                                                        ))}


                                                        {param.type === "Product" && ContractStatuses.filter((item: any) => !param.data.some((values: any) => item.text?.includes(values.text))).map((values: any, index: any) => (

                                                            <>{(values.productStatusName) && <a key={1} className="btn mb ws-12 ms p0" style={{ background: pickerColors[index], color: "#FFFFFF" }}>
                                                                <span className="ws-10 mt text-center forceSingleLine" style={{ background: pickerColors[index], color: "#FFFFFF" }}>{values.productStatusName}</span>
                                                                <span className="pull-right ws-2 pr pt" onClick={() => addProductTag(values)}>
                                                                    <i className="icon-plus1 text-xl"></i>
                                                                </span>
                                                            </a>}

                                                                {(!values.productStatusName) && <li>No Tags Available</li>}</>

                                                        ))}

                                                    </ul>


                                                </div>

                                            </div>
                                        </div>
                                        <div className="ws-6 pm">
                                            <div className="box">
                                                <div className="box-header">  <h1 className="panel-title">Exclude</h1> </div>
                                                <div className="box-content">
                                                    <ul dnd-list="models.lists.Available" className="listStyle pLarge">
                                                        {(excludedContractStatuses.length === 0 && param.type === "Contract") && <li>No Tags Available</li>}
                                                        {(excludedProductStatuses.length === 0 && param.type === "Product") && <li>No Tags Available</li>}

                                                        {param.type === "Contract" && excludedContractStatuses.map((contractStatus: any, index: any) => (
                                                            <a key={index} className="btn mb ws-12 ms p0" style={{ background: pickerColors[index], color: "#FFFFFF" }}>
                                                                <span className="ws-10 mt text-center forceSingleLine" style={{ background: pickerColors[index], color: "#FFFFFF" }}>{contractStatus.text}</span>
                                                                <span className="pull-right ws-2 pr pt" onClick={() => removeProductTag(contractStatus)}>
                                                                    <i className="icon-cancel1 text-xl"></i>
                                                                </span>
                                                            </a>
                                                        ))}

                                                        {param.type === "Product" && excludedProductStatuses.map((contractStatus: any, index: any) => (
                                                            <a key={index} className="btn mb ws-12 ms p0" style={{ background: pickerColors[index], color: "#FFFFFF" }}>
                                                                <span className="ws-10 mt text-center forceSingleLine" style={{ background: pickerColors[index], color: "#FFFFFF" }}>{contractStatus.text}</span>
                                                                <span className="pull-right ws-2 pr pt" onClick={() => removeProductTag(contractStatus)}>
                                                                    <i className="icon-cancel1 text-xl"></i>
                                                                </span>
                                                            </a>
                                                        ))}

                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="box-footer">
                                    <button className="icon-btn delete" onClick={() => { closeStatus() }}><i className="fa fa-close"></i>  Close  </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </Modal>
        </>
    )
}